module.exports = __webpack_public_path__ + "static/media/profile_picture_1.1df99766.jpg";